import { Injectable, NgZone, OnDestroy } from '@angular/core'
import { DeviceDetectorService } from 'ngx-device-detector'
import { Observable, Subscription } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class CurrentDeviceService implements OnDestroy {
  /** The current device is mobile */
  isMobile: boolean

  /** Is landscape  */
  isLandscape: boolean = false

  private orientationSubscription: Subscription

  private orientationSubject: Observable<DeviceOrientationEvent>

  constructor(private zone: NgZone, private deviceService: DeviceDetectorService) {
    this.isMobile = this.deviceService.isMobile()
    this.orientationSubject = new Observable<DeviceOrientationEvent>((observer) => {
      if (deviceService.isMobile()) {
        if (window.DeviceOrientationEvent) {
          window.addEventListener('deviceorientation', (event: DeviceOrientationEvent) => {
            this.zone.run(() => {
              observer.next(event)
            })
          })
        } else {
          console.warn('Device orientation not supported on this device.')
        }
      } else {
        console.warn('Not a mobile device. Orientation events not supported.')
      }
    })

    // Only subscribe if we're on a mobile device to avoid unnecessary subscriptions
    if (this.isMobile) {
      try {
        this.orientationSubscription = this.getOrientation().subscribe((_event: DeviceOrientationEvent) => {
          this.isLandscape = true
        })
      } catch (error) {
        console.warn('Failed to subscribe to orientation changes:', error)
      }
    }
  }

  private cleanup(): void {
    if (this.orientationSubscription) {
      this.orientationSubscription.unsubscribe()
    }
  }

  getOrientation(): Observable<DeviceOrientationEvent> {
    return this.orientationSubject
  }

  ngOnDestroy(): void {
    this.cleanup()
  }
}
